import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { DataTrackMessage } from "../../../constants";
import Modal from "../../Generic/Modal";
import useVideoContext from "../hooks/useVideoContext/useVideoContext";
import useStyles from "./styles";

const ModalEnterRoom = () => {
  const classes = useStyles();
  const { t: translate } = useTranslation();
  const {
    dataTrack,
    task,
    participantsRequestedAccess,
    setParticipantsRequestedAccess,
    participantsAllowed,
    setParticipantsAllowed,
  } = useVideoContext();

  const [openModalEnterRoom, setOpenModalEnterRoom] = useState(false);

  useEffect(() => {
    if (participantsRequestedAccess.length > 0 && !openModalEnterRoom) setOpenModalEnterRoom(true);
  }, [participantsRequestedAccess]);

  const onAllow = () => {
    dataTrack.send(DataTrackMessage.ALLOW_REQUEST_ENTER_ROOM);
    if (participantsRequestedAccess && participantsRequestedAccess.length > 0) {
      const participantAllowed = participantsRequestedAccess[0];

      const participantsRequestedAccessUpdated = [...participantsRequestedAccess];

      participantsRequestedAccessUpdated?.shift();

      setParticipantsRequestedAccess(participantsRequestedAccessUpdated);
      setParticipantsAllowed([...participantsAllowed, participantAllowed]);
    }
    setOpenModalEnterRoom(false);
  };

  const onNotAllow = () => {
    dataTrack.send(DataTrackMessage.NOT_ALLOW_REQUEST_ENTER_ROOM);
    if (participantsRequestedAccess && participantsRequestedAccess.length > 0) {
      const participantsRequestedAccessUpdated = [...participantsRequestedAccess];

      participantsRequestedAccessUpdated?.shift();
      setParticipantsRequestedAccess(participantsRequestedAccessUpdated);
    }
    setOpenModalEnterRoom(false);
  };

  return (
    <Modal
      title={translate("allowCustomer")}
      className={classes.modal}
      open={openModalEnterRoom}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      onClose={(_, reason) => {
        if (reason === "backdropClick") false;
      }}
      showActionButtons
      actionButtonProps={{
        textSave: translate("allow"),
        textCancel: translate("notAllow"),
        onSave: onAllow,
        onCancel: onNotAllow,
      }}
    >
      <h3 className={classes.text}>
        {task?.job?.customer?.fullName || "Customer"} wants to enter this room.
      </h3>
    </Modal>
  );
};

export default ModalEnterRoom;
